var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        showTitle: false,
        showFooter: false,
        "class-name": "visitor-detail-popup",
      },
      on: { cancel: _vm.closePopup },
    },
    [
      _c("VisitorDetail", {
        attrs: {
          visitorId: _vm.visitorDetailPopup,
          visibleMail: _vm.visibleMail,
        },
        on: { detailClose: _vm.detailClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }